import FetchByObjectConfig from '../Helpers/FetchByObjectConfig';
import {getToken} from '../helpers';

export const getFilesDownloadedRequest = ({page, perPage, statusRequest, requestType}) => {
    const config = {
        path: `gestionxml?page=${page}&per_page=${perPage}&status_request=${statusRequest}&request_type=${requestType}&documents=Todos`,
        method: 'GET',
    };
    return FetchByObjectConfig(config);
}

export const getFilesDownloadedWithFilterRequest = (data) => {
    const {page, perPage, status, type, documents, taxId, startDate, endDate, taxIdIssuer} = data;
    const config = {
        path: `gestionxml?page=${page}&per_page=${perPage}&status_request=${status}&documents=${documents}&tax_id=${taxId}&start_date=${startDate}&end_date=${endDate}&request_type=${type}&tax_id_issuer=${taxIdIssuer}`,
        method: 'GET',
    };
    return FetchByObjectConfig(config);
}


export const getZipsFromFilePathRequest = (filePath) => {
    let body = {
        PathFile: filePath
    };

    const config = {
        path: 'file',
        method: 'POST',
        body,
    };
    return FetchByObjectConfig(config);
}

export const generateDownloadRequest = ({startDate, endDate, taxId, type, documents, generatePDF, rfcEmisor, rfcReceptor, googleDrive, rfcTPAccount, cfdiType, cfdiComplement, CFDIStatus, includeCancellationDate}) => {
    let body = {
        StartDate: startDate,
        EndDate: endDate,
        TaxId: taxId,
        requestType: type,
        DocumentType: documents,
        GeneratePDF: generatePDF,
        RfcEmisor: rfcEmisor,
        GoogleDrive: googleDrive,
        RfcReceptor: rfcReceptor,
        RfcTPAccount: rfcTPAccount,
        CFDIType: cfdiType,
        CFDIComplement: cfdiComplement,
        CFDIStatus: CFDIStatus,
        includeStatus: includeCancellationDate
    };

    const config = {
        path: 'gestionxml',
        method: 'POST',
        body,
    };
    return FetchByObjectConfig(config);
}

export const generateDownloadHistoricalRequest = body => {
    const config = {
        path: 'gestionxml/historical',
        method: 'POST',
        body,
    };
    return FetchByObjectConfig(config);
}

export const generateScheduleRequest = ({includeCancellationDate, ...rest}) => {
    const body = {...rest, includeStatus: includeCancellationDate};
    const config = {
        path: 'gestionxml/schedule',
        method: 'POST',
        body,
    };
    return FetchByObjectConfig(config);
}

export const generateGetScheduleRequest = ({page, perPage}) => {

    const config = {
        path: `gestionxml/schedule?page=${page}&perPage=${perPage}`,
        method: 'GET'
    };
    return FetchByObjectConfig(config);
}
export const ActivateSchedule = ({taxId, processType, documentType}) => {

    const config = {
        path: `gestionxml/schedule/${taxId}/${documentType}/${processType}`,
        method: 'POST'
    };
    return FetchByObjectConfig(config);
}
export const DesctivateSchedule = ({taxId, processType, documentType}) => {

    const config = {
        path: `gestionxml/schedule/${taxId}/${documentType}/${processType}`,
        method: 'DELETE'
    };
    return FetchByObjectConfig(config);
}

// Construye el querystring de filtros para search/export de descargas programadas.
// Solo agrega los filtros con valor (null/undefined/'' = no aplica).
const buildScheduleFilterParams = (filters = {}) => {
    const parts = [];
    const append = (key, value) => {
        if (value === null || value === undefined || value === '') return;
        parts.push(`${key}=${encodeURIComponent(value)}`);
    };
    (filters.taxIds || []).forEach(taxId => append('taxIds', taxId));
    append('documentType', filters.documentType);
    append('processType', filters.processType);
    append('frequencyInDays', filters.frequencyInDays);
    append('cfdiType', filters.cfdiType);
    append('cfdiComplement', filters.cfdiComplement);
    append('cfdiStatus', filters.cfdiStatus);
    append('active', filters.active);
    return parts;
};

export const searchScheduleRequest = ({page = 1, perPage = 10, filters = {}}) => {
    const parts = [`page=${page}`, `perPage=${perPage}`, ...buildScheduleFilterParams(filters)];
    const config = {
        path: `gestionxml/schedule/search?${parts.join('&')}`,
        method: 'GET'
    };
    return FetchByObjectConfig(config);
}

export const updateScheduleConfigRequest = ({taxId, documentType, processType, changes}) => {
    const config = {
        path: `gestionxml/schedule/${taxId}/${documentType}/${processType}`,
        method: 'PATCH',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: changes
    };
    return FetchByObjectConfig(config);
}

export const removeScheduleConfigRequest = ({taxId, documentType, processType}) => {
    const config = {
        path: `gestionxml/schedule/${taxId}/${documentType}/${processType}/remove`,
        method: 'DELETE'
    };
    return FetchByObjectConfig(config);
}

// Descarga CSV en streaming: no pasa por FetchByObjectConfig porque la respuesta no es JSON.
export const exportScheduleConfigsRequest = (filters = {}) => {
    const parts = buildScheduleFilterParams(filters);
    const query = parts.length ? `?${parts.join('&')}` : '';
    return fetch(`/api/gestionxml/schedule/export${query}`, {
        method: 'GET',
        headers: {
            Authorization: 'Bearer ' + getToken()
        }
    }).then(response => {
        if (!response.ok)
            throw new Error('Ocurrió un error al exportar las configuraciones');
        return response.blob();
    });
}

export const getTaxpayerVolumenRequest = () => {
    const config = {
        path: 'taxpayerVolume',
        method: 'GET',
    };
    return FetchByObjectConfig(config);
}

export const getCertificatesRequest = ({page, perPage}) => {
    const config = {
        path: `certificates?page=${page}&per_page=${perPage}`,
        method: 'GET',
    };
    return FetchByObjectConfig(config);
}

export const generateVolumeRequest = (taxId) => {
    let body = {
        Taxid: taxId
    };

    const config = {
        path: 'taxpayerVolume',
        method: 'POST',
        body,
    };
    return FetchByObjectConfig(config);
}

export const getEfosRequestDataRequest = data => {
    let {page = 1, perPage = 5} = data;
    const config = {
        path: `gestionxml?page=${page}&per_page=${perPage}&status_request=-1&request_type=2&documents=Todos`,
        method: 'GET',
        data,
    };
    return FetchByObjectConfig(config);
}

export const createEfosRequest = body => {
    const config = {
        path: 'gestionxml/metadata',
        method: 'POST',
        body,
    };
    return FetchByObjectConfig(config);
}

export const getLastEfosRequest = () => {
    const config = {
        path: 'gestionxml/lastEfosRequest',
        method: 'GET',
    };
    return FetchByObjectConfig(config);
}

export const changePasswordRequest = ({email, token}) => {
    const config = {
        path: 'account/changePasswordRequest',
        method: 'POST',
        headers: {
            email,
            token
        }
    };
    return FetchByObjectConfig(config);
}

